import React from "react";

const RockStar = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="m17.889 9.05-3.042 9.53 3.042-9.53ZM22.812 24.47l7.966-5.89-7.966 5.89ZM9.923 34l7.966-5.89L9.923 34Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M30.778 18.58 18.82 21.524 17.89 9.05l-3.042 9.53L9.923 34l7.966-5.89 4.923-3.64 7.966-5.89ZM18.563 28.608 25.855 34l-2.785-8.724-4.507 3.332ZM13.996 18.58H5l7.278 5.38 1.718-5.38ZM10.318 32.765 9.923 34l.395-1.235Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M22.801 17.976c1.413 0 2.558-1.166 2.558-2.604 0-1.438-1.145-2.603-2.558-2.603-1.412 0-2.558 1.165-2.558 2.603 0 1.438 1.146 2.604 2.558 2.604ZM12.905 16.966c1.093-.47 1.604-1.752 1.142-2.863a2.133 2.133 0 0 0-2.814-1.162c-1.092.47-1.603 1.752-1.14 2.863a2.133 2.133 0 0 0 2.812 1.162ZM18.884 2l.168 1.619c.054.521.46.934.972.989l1.59.171-1.59.172a1.103 1.103 0 0 0-.972.99l-.168 1.618-.169-1.619a1.103 1.103 0 0 0-.972-.99l-1.59-.17 1.59-.172c.513-.055.918-.468.972-.99L18.884 2ZM24.369 3.619l.07.675a.46.46 0 0 0 .407.413l.664.072-.664.072a.46.46 0 0 0-.406.414l-.071.675-.07-.675a.46.46 0 0 0-.407-.414l-.664-.072.664-.072a.46.46 0 0 0 .406-.413l.071-.675ZM12.284 7.889l.07.675a.46.46 0 0 0 .407.414l.664.072-.664.071a.46.46 0 0 0-.406.414l-.071.675-.07-.675a.46.46 0 0 0-.407-.414l-.664-.071.664-.072a.46.46 0 0 0 .406-.414l.071-.675ZM23.71 8.133l.071.675a.46.46 0 0 0 .406.414l.664.072-.664.072a.46.46 0 0 0-.406.413l-.07.675-.071-.675a.46.46 0 0 0-.406-.413l-.664-.072.664-.072a.46.46 0 0 0 .406-.414l.07-.675ZM13.506 5.09l.059.566c.018.182.16.326.339.345l.555.06-.555.06a.384.384 0 0 0-.34.344l-.058.565-.059-.565a.384.384 0 0 0-.339-.345l-.555-.06.555-.06a.384.384 0 0 0 .34-.344l.058-.565Z"
            fill={fill}
        />
    </svg>
);

export default RockStar;
